/** 
*@author: satyamurthy.a
*@Description : 
**/
import React, { useState, useEffect } from 'react';
import "../CSS/EAM.css";
import moment from "moment";
import { connect } from "react-redux";
import { encode as base64_encode } from "base-64";
import { Button, Row, Col, Card, Avatar, Space, message, Tag } from 'antd';
import {
  getLandingPageCount,
  getPendingList,
  updateStatus,
} from "../Utils/FormCalls";
import {
  EditOutlined,
  MailOutlined,
  UserOutlined,
  AlertOutlined,
  AimOutlined
} from '@ant-design/icons';
import StyledTable from "../../../commons/styles/table";
import translation from "../../../commons/translation";

const { Meta } = Card;

const EAMLandingPage = (props) => {
  const [listData, setListData] = useState({
    OpenWorkOrders: '-',
    Notifications: '-',
    PendingWorkOrders: '-',
    ClosedWorkOrders: '-'
  });
  const [pendingList, setPendingList] = useState([]);
  const [loading, setLoading] = useState(true); 

  useEffect(() => {
    getWorkOrderList();
    getListData();
  }, [props.UserDetails]);

const getListData = async () => {
  const payload = {
    UserId: props.UserDetails?.Id || '',
    UserName: props.UserDetails?.UserName || ''
  };
  
  if (!payload.UserId) {
    setLoading(false);
    return;
  }

  try {
    const response = await getLandingPageCount(payload);
    
    if (!response) {
      throw new Error('No response received from server');
    }

    setListData({
      OpenWorkOrders: response.OpenWorkOrders ?? '-',
      Notifications: response.Notifications ?? '-',
      PendingWorkOrders: response.PendingWorkOrders ?? '-',
      ClosedWorkOrders: response.ClosedWorkOrders ?? '-'
    });
  } catch (error) {
    console.error('Error fetching dashboard data:', error);
    message.error(error.message || 'Failed to load dashboard data');
    
    // Set default values when API fails
    setListData({
      OpenWorkOrders: 'Error',
      Notifications: 'Error', 
      PendingWorkOrders: 'Error',
      ClosedWorkOrders: 'Error'
    });
  } finally {
    setLoading(false);
  }
};


  const getWorkOrderList = async () => {
    try {
      const list = await getPendingList();
      setPendingList(list.data || []);
    } catch (error) {
      message.error(error.response?.data?.message || 'Failed to load pending list');
      setPendingList([]);
    }
  };

  const updateWorkStatus = async (record, status) => {
    try {
      await updateStatus(record, status);
      const list = await getPendingList();
      setPendingList(list.data || []);
    } catch (error) {
      message.error(error.response?.data?.message || 'Failed to update status');
    }
  };

  if (loading) {
    return <div style={{ textAlign: 'center', padding: '50px' }}>Loading dashboard data...</div>; // ADDED: Loading indicator
  }

  const columns = [
    {
      title: translation(props.translationCache, 'Created Date & Time'),
      dataIndex: 'CreatedTime',
      key: 'CreatedTime',
      render: (text) => (
        <a href="window.location">{moment(text).utc().format('YYYY-MM-DD HH:mm:ss')}</a>
      )
    },
    {
      title: translation(props.translationCache, 'Work Order'),
      dataIndex: 'WorkOrder',
      key: 'WorkOrder'
    },
    {
      title: translation(props.translationCache, 'Status'),
      dataIndex: 'Status',
      key: 'Status'
    },
    {
      title: translation(props.translationCache, 'Action'),
      key: 'action',
      render: (_, record) => (
        <Space >
          {record.futureStatusActions &&
            record.futureStatusActions.map((item, i) => (
              <Tag
                style={{ cursor: 'pointer' }}
                color={'#87d068'}
                key={i}
                onClick={() => updateWorkStatus(record, item.ConnectionStatus)}
              >
                {item.ConnectionStatus}
              </Tag>
            ))}
          <Button
            style={{ marginRight: '5px' }}
            type="primary"
            onClick={() => props.navigate(`/rubus/AMM/WorkOrderDetails/${base64_encode(record.Id)}`)}
          >
            <EditOutlined />
          </Button>
        </Space>
      )
    }
  ];

  return (
    <>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col className="gutter-row" span={6}>
          <Card className="notify">
            <Meta
              avatar={
                <Avatar
                  className="notifyCard"
                  style={{ background: '#007bff' }}
                  icon={<UserOutlined />}
                />
              }
              title={listData.OpenWorkOrders}
              description={translation(props.translationCache, 'Open Work Orders')}
            />
          </Card>
        </Col>
        <Col className="gutter-row" span={6}>
          <Card className="notify">
            <Meta
              avatar={
                <Avatar
                  className=" notifyCard"
                  style={{ background: '#faad14' }}
                  icon={<MailOutlined />}
                />
              }
              title={listData.Notifications}
              description={translation(props.translationCache, 'Notifications')}
            />
          </Card>
        </Col>
        <Col className="gutter-row" span={6}>
          <Card className="notify">
            <Meta
              avatar={
                <Avatar
                  className="notifyCard"
                  style={{ background: '#f5222d' }}
                  icon={<AimOutlined />}
                />
              }
              title={listData.PendingWorkOrders}
              description={translation(props.translationCache, 'Pending Work Orders')}
            />
          </Card>
        </Col>
        <Col className="gutter-row" span={6}>
          <Card className="notify">
            <Meta
              avatar={
                <Avatar
                  className="notifyCard"
                  style={{ background: '#faad14' }}
                  icon={<AlertOutlined />}
                />
              }
              title={listData.ClosedWorkOrders}
              description={translation(props.translationCache, 'Complete Work Order')}
            />
          </Card>
        </Col>
      </Row>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col className="gutter-row eamCard" span={24}>
          <Card title={translation(props.translationCache, 'Pending Approvals')}>
            <StyledTable size="small" columns={columns} dataSource={pendingList} scroll={{ x: 1000, y: 200 }} />
          </Card>
        </Col>
      </Row>
    </>
  );
};

const mapStateToProps = (state) => ({
  UserDetails: state.LayoutReducer.UserDetails,
  translationCache: state.TranslationReducer.translationCache,
});

export default connect(mapStateToProps)(EAMLandingPage);
